export const WINDOW_TITLE = "Dashboard";



// WEBPACK FOOTER //
// ./src/constants/meta.ts